import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateMarketingBanner from "../../components/Settings/MarketingBanner/UpdateMarketingBanner";

export const UpdateMarketingBannerPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateMarketingBanner />
        </div>
      </div>
    </div>
  );
};
